<template>
  <div>
    <Lottieloader v-if="$isLoading" />
    
    <div v-show="!$isLoading">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup lang="ts">
import Lottieloader from './components/loader/Lottieloader.vue';

const { $isLoading } = useNuxtApp()

// Titles are set per-page; no global useHead title here
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.nuxt-loading-indicator {
  display: none !important;
}
</style>
